import React from "react";
import { observer } from "mobx-react";
import OrdersList from "./components/OrdersList";

const ClientOrdersPage = () => {
    return(
        <OrdersList/>
    );
};

export default observer(ClientOrdersPage);
